__turbopack_context__.v({
  "Feature": "question-module__2Xzb3q__Feature",
  "acheivername": "question-module__2Xzb3q__acheivername",
  "acheiverrank": "question-module__2Xzb3q__acheiverrank",
  "acheiverrank1": "question-module__2Xzb3q__acheiverrank1",
  "bgbox": "question-module__2Xzb3q__bgbox",
  "bground": "question-module__2Xzb3q__bground",
  "bluetxt": "question-module__2Xzb3q__bluetxt",
  "btnbox": "question-module__2Xzb3q__btnbox",
  "captcha": "question-module__2Xzb3q__captcha",
  "card": "question-module__2Xzb3q__card",
  "centerValue": "question-module__2Xzb3q__centerValue",
  "checkboxcontent": "question-module__2Xzb3q__checkboxcontent",
  "contactheader": "question-module__2Xzb3q__contactheader",
  "customFileUploader": "question-module__2Xzb3q__customFileUploader",
  "dayValue": "question-module__2Xzb3q__dayValue",
  "facultyborder1": "question-module__2Xzb3q__facultyborder1",
  "formstar": "question-module__2Xzb3q__formstar",
  "hover-shadow": "question-module__2Xzb3q__hover-shadow",
  "input-group-btn": "question-module__2Xzb3q__input-group-btn",
  "invalidCheck2": "question-module__2Xzb3q__invalidCheck2",
  "mbtableheading": "question-module__2Xzb3q__mbtableheading",
  "normalbutton": "question-module__2Xzb3q__normalbutton",
  "pagemaintitle": "question-module__2Xzb3q__pagemaintitle",
  "paybill": "question-module__2Xzb3q__paybill",
  "posting": "question-module__2Xzb3q__posting",
  "redbtn": "question-module__2Xzb3q__redbtn",
  "redunderline": "question-module__2Xzb3q__redunderline",
  "responsiveImage": "question-module__2Xzb3q__responsiveImage",
  "section1bgbox": "question-module__2Xzb3q__section1bgbox",
  "section1title": "question-module__2Xzb3q__section1title",
  "sectionsubtitle": "question-module__2Xzb3q__sectionsubtitle",
  "sectiontitle": "question-module__2Xzb3q__sectiontitle",
  "sectiontitlesub": "question-module__2Xzb3q__sectiontitlesub",
  "selected": "question-module__2Xzb3q__selected",
  "startDate": "question-module__2Xzb3q__startDate",
  "table1": "question-module__2Xzb3q__table1",
  "tableheading": "question-module__2Xzb3q__tableheading",
  "tablepara": "question-module__2Xzb3q__tablepara",
  "tablescroll": "question-module__2Xzb3q__tablescroll",
  "tabletitle": "question-module__2Xzb3q__tabletitle",
  "ulclass": "question-module__2Xzb3q__ulclass",
  "ulliclass": "question-module__2Xzb3q__ulliclass",
  "ullispan": "question-module__2Xzb3q__ullispan",
});
